import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MatTabGroup } from '@angular/material';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
// import { query } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
// import { text, element } from '@angular/core/src/render3/instructions';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-invoice-design',
  templateUrl: './invoice-design.component.html',
  styleUrls: ['./invoice-design.component.css']
})
export class InvoiceDesignComponent implements OnInit {

  fieldValues = new FormControl();

  design_model = {
    'table_name': 'invoice_design', 'invoice_design_id': '0', 'invoice_design_name': '',
    'invoice_design_name_en': '', 'show_page_header': 0, 'header_font': 'aealarabiya', 'header_font_size': '11',
    'page_dir': 'rtl', 'page_layout': 'P', 'page_format': 'A4', 'page_unit': 'mm', 'page_font': 'aealarabiya',
    'page_font_size': '10', 'draw_invoice_table': 0, 'show_table_header': 0, 'one_line_table_header': 0, 
    'flag': 'new', 'key': 'invoice_design_id', 'invoice_table_x': '10', 'invoice_table_y': '72', 
    'invoice_table_height': '170', 'draw_invoice_total': 0, 'show_total_header': 0, 'one_line_total_header': 0, 
    'invoice_total_x': '10', 'invoice_total_y': '242', 'show_terms_table': 0, 'terms_table_place': 'separate_page_last', 
    'draw_terms_table': 0, 'show_terms_header': 0, 'terms_header': 'شروط وأحكام الفاتورة', 
    'terms_header_en': 'Invoice Terms & Conditions', 'one_line_terms_header': 0, 'terms_table_x': '0', 
    'terms_table_y': '0', 'terms_table_width': '190', 'terms_text_align': 'right', 'is_active': 0, 
    'comment': ''
  };

  field_model = {
    'table_name': 'invoice_design_field', 'invoice_field_id': '0', 'invoice_design_id': '', 'field_title': '',
    'field_title_en': '', 'field_value': '', 'show_title': 1, 'one_line_title': 1, 'is_header': 0,
    'one_box': 0, 'title_font_size': '10', 'title_align': 'R', 'title_width': '0', 'title_height': '7',
    'title_x': '0', 'title_y': '0', 'title_border': 0, 'value_font_size': '10', 'value_align': 'R',
    'flag': 'new', 'key': 'invoice_field_id', 'value_width': '0', 'value_height': '7', 'value_x': '0',
    'value_y': '0', 'value_border': 0, 'comment': ''
  };

  // table_model = {
  //   'table_name': 'invoice_design_table', 'invoice_table_id': '0', 'invoice_design_id': '',
  //   'invoice_column_id': '', 'column_title': '', 'column_title_en': '', 'show_title': 0,
  //   'one_line_title': 0, 'column_width': '0', 'column_seq': '', 'comment': ''
  // } 'show_title',
    // 'one_line_title', 

  data_model = { 'activity': 'معطل' }; 

  fieldDisplayedColumns = ['field_title', 'title_x', 'title_y', 'value_x', 'value_y', 'edit', 'del'];

  colDisplayedColumns = ['choose', 'column_title', 'column_title_en', 'column_width', 'column_seq'];

  totalDisplayedColumns = ['choose', 'column_title', 'column_title_en', 'column_width',
    'column_seq', 'content'];

  contentDisplayedColumns = ['choose', 'column_title', 'column_title_en'];

  value_list = [];
  all_content_list = [];

  private field_list = [];
  private column_list = [];
  private total_list = [];
  private content_list = [];

  fieldDataSource = new MatTableDataSource(this.field_list);
  colDataSource = new MatTableDataSource(this.column_list);
  totalDataSource = new MatTableDataSource(this.total_list);
  contentDataSource = new MatTableDataSource(this.content_list);
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  heightField = '';

  dir_list = [{ 'dir_key': 'rtl', 'dir_ar': 'من اليمين إلى اليسار', 'dir_en': 'From right to left' },
  { 'dir_key': 'ltr', 'dir_ar': 'من اليسار إلى اليمين', 'dir_en': 'From left to right' }];

  layout_list = [{ 'layout_key': 'P', 'layout_ar': 'طولي', 'layout_en': 'Portrait' },
  { 'layout_key': 'L', 'layout_ar': 'عرضي', 'layout_en': 'Landscape' }];

  size_list = [{ 'size_name': 'A4' }, { 'size_name': 'A3' },
  { 'size_name': 'Letter' }];

  unit_list = [{ 'unit_en': 'mm', 'unit_ar': 'ملم' },
  { 'unit_en': 'cm', 'unit_ar': 'سم' }];

  font_list = [{ 'font_name': 'aealarabiya' }];

  align_list = [{ 'align_key': 'L', 'align_en': 'Left', 'align_ar': 'يسار' },
  { 'align_key': 'R', 'align_en': 'Right', 'align_ar': 'يمين' },
  { 'align_key': 'C', 'align_en': 'Center', 'align_ar': 'وسط' }];
  // { 'align_key': 'J', 'align_en': 'Justify', 'align_ar': 'ملئ الصفحة' }];

  terms_place = [
    { 'place_key': 'same_page_last', 'place_ar': 'نفس صفحة الفاتورة (آخر صفحة في الفاتورة)', 
      'place_en': 'Same Invoice Page (Last Page in Invoice)' },
    { 'place_key': 'same_page_each', 'place_ar': 'نفس صفحة الفاتورة (كل صفحة في الفاتورة) ', 
      'place_en': 'Same Invoice Page (Each Page in Invoice)' },
    { 'place_key': 'separate_page_last', 'place_ar': 'صفحة مستقلة بعد آخر صفحة في الفاتورة', 
      'place_en': 'Separate Page after Last Page in Invoice' },
    { 'place_key': 'separate_page_each', 'place_ar': 'صفحة مستقلة بعد كل صفحة في الفاتورة', 
      'place_en': 'Separate Page after Each Page in Invoice' }
  ];

  // table_column_values = [];
  // content_column_values = [];
  // content_data_list = [];

  mode = '';
  toDelete = [];

  fieldsetDisabled = false;

  Success_Msg; Error_Msg; Del_Msg; Active; Inactive; Title_Msg; Value_Msg;
  Del_Field_Msg; Design_Name_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private route: ActivatedRoute, private router: Router,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Active').subscribe((res: string) => {
      this.Active = res;
    });

    translate.get('Inactive').subscribe((res: string) => {
      this.Inactive = res;
    });

    translate.get('Title_Msg').subscribe((res: string) => {
      this.Title_Msg = res;
    });

    translate.get('Value_Msg').subscribe((res: string) => {
      this.Value_Msg = res;
    });

    translate.get('Del_Field_Msg').subscribe((res: string) => {
      this.Del_Field_Msg = res;
    });

    translate.get('Design_Name_Msg').subscribe((res: string) => {
      this.Design_Name_Msg = res;
    });

  }

  ngOnInit() {

    //Get Invoice Value:
    let query, obj;
    query = "SELECT * FROM `invoice_value` WHERE `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.value_list = data.data['list'];
      });

    
    /////////////////////////  EDIT OR COPY /////////////////////////
    this.route.params.subscribe(params => {
      if (params['id'] != undefined) {
        this.design_model['invoice_design_id'] = params['id'];
        this.mode = params['mode'];

        //******** Get design information ********//
        query = "SELECT * FROM `invoice_design` WHERE `invoice_design_id` = '" + this.design_model['invoice_design_id'] + 
          "' AND `status` = '1'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let design_obj = data.data['list'][0];

            this.design_model = {
              'table_name': 'invoice_design', 'invoice_design_id': design_obj['invoice_design_id'],
              'invoice_design_name': design_obj['invoice_design_name'], 
              'invoice_design_name_en': design_obj['invoice_design_name_en'],
              'show_page_header': Number(design_obj['show_page_header']), 
              'header_font': design_obj['header_font'], 'header_font_size': design_obj['header_font_size'], 
              'page_dir': design_obj['page_dir'], 'page_layout': design_obj['page_layout'],
              'page_format': design_obj['page_format'], 'page_unit': design_obj['page_unit'], 
              'page_font': design_obj['page_font'], 'page_font_size': design_obj['page_font_size'], 
              'draw_invoice_table': Number(design_obj['draw_invoice_table']),
              'show_table_header': Number(design_obj['show_table_header']), 
              'one_line_table_header': Number(design_obj['one_line_table_header']), 
              'flag': (this.mode == 'copy' ? 'new' : 'update'), 'key': 'invoice_design_id', 
              'invoice_table_x': design_obj['invoice_table_x'], 'invoice_table_y': design_obj['invoice_table_y'], 
              'invoice_table_height': design_obj['invoice_table_height'], 
              'draw_invoice_total': Number(design_obj['draw_invoice_total']),
              'show_total_header': Number(design_obj['show_total_header']), 
              'one_line_total_header': Number(design_obj['one_line_total_header']), 
              'invoice_total_x': design_obj['invoice_total_x'], 'invoice_total_y': design_obj['invoice_total_y'],
              'show_terms_table': Number(design_obj['show_terms_table']), 
              'terms_table_place': design_obj['terms_table_place'], 
              'draw_terms_table': Number(design_obj['draw_terms_table']), 
              'show_terms_header': Number(design_obj['show_terms_header']), 
              'terms_header': design_obj['terms_header'], 'terms_header_en': design_obj['terms_header_en'],
              'one_line_terms_header': Number(design_obj['one_line_terms_header']), 
              'terms_table_x': design_obj['terms_table_x'], 'terms_table_y': design_obj['terms_table_y'],
              'terms_table_width': design_obj['terms_table_width'], 'terms_text_align': design_obj['terms_text_align'],
              'is_active': (this.mode == 'copy' ? 0 : (design_obj['is_active'] == '1' ? 1 : 0)), 
              'comment': design_obj['comment']
            };

            if (this.design_model['is_active'] == 1) 
              this.data_model['activity'] = this.Active;
            else
              this.data_model['activity'] = this.Inactive;

            //Disable all the inputs if it is the default design (Can't edit the default design)
            if (this.design_model['invoice_design_id'] == '1' && this.mode == 'edit')
              this.fieldsetDisabled = true;
          });

        //******** Get field list ********//
        query = "SELECT * FROM `invoice_design_field` WHERE `invoice_design_id` = '" + this.design_model['invoice_design_id'] + 
          "' AND `status` = '1'"; 
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let field_data = data.data['list'];
            let index = 0;

            field_data.forEach(element => {

              this.field_list.push({
                'table_name': 'invoice_design_field', 
                'invoice_field_id': (this.mode == 'edit' ? element.invoice_field_id : '0'), 
                'invoice_design_id': element.invoice_design_id, 'field_title': element.field_title, 
                'field_title_en': element.field_title_en, 'field_value': (element.field_value).split(";"),
                'show_title': (element.show_title == '1' ? 1 : 0), 
                'one_line_title': (element.one_line_title == '1' ? 1 : 0),
                'is_header': (element.is_header == '1' ? 1 : 0), 'one_box': (element.one_box == '1' ? 1 : 0),
                'title_font_size': element.title_font_size, 'title_align': element.title_align, 
                'title_width': element.title_width, 'title_height': element.title_height, 
                'title_x': element.title_x, 'title_y': element.title_y,
                'title_border': (element.title_border == '1' ? 1 : 0), 
                'value_font_size': element.value_font_size, 'value_align': element.value_align,
                'flag': (this.mode == 'edit' ? 'update' : 'new'), 'key': 'invoice_field_id', 
                'value_width': element.value_width, 'value_height': element.value_height, 
                'value_x': element.value_x, 'value_y': element.value_y, 
                'value_border': (element.value_border == '1' ? 1 : 0), 'comment': element.comment, 
                'index': index
              });
              index++;
            });
            console.log('field_list: ');
            console.log(this.field_list);
            this.fieldDataSource = new MatTableDataSource(this.field_list);
            this.fieldDataSource.sort = this.sort;
          });
      }
    });


    //Get Invoice Columns
    this.getInvoiceColumn();
  }

  ///////////////////////// Get Invoice Columns /////////////////////////
  getInvoiceColumn() {
    //******** invoice item table ********//
    let query, obj;
    query = "SELECT * FROM `invoice_column` WHERE `column_type` = 'invoice_table' AND `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.column_list = data.data['list'];

        // get invoice item table columns for invoice design
        if (this.design_model['invoice_design_id'] != '0') {

          query = "SELECT * FROM `invoice_design_table` WHERE `invoice_design_id` = '" +
            this.design_model['invoice_design_id'] + "' AND `status` = '1'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              let col_data = data.data['list'];

              this.column_list.forEach(column => {
                column.invoice_table_id = '0';
                column.is_default = '0';
                column.flag = 'new';
                // column.exist = false;
                col_data.forEach(element => {

                  if (element.invoice_column_id == column.invoice_column_id) {
                    if (this.mode == 'edit')
                      column.invoice_table_id = element.invoice_table_id;

                    column.is_default = '1';
                    // column.exist = true;
                    column.column_title = element.column_title;
                    column.column_title_en = element.column_title_en;
                    column.column_width = element.column_width;
                    column.column_seq = element.column_seq;
                    
                    if (this.mode == 'edit')
                      column.flag = 'update';
                    else 
                      column.flag = 'new';
                  }
                }); 

              });
            });
        }
        else {
          this.column_list.forEach(column => {
            column.invoice_table_id = '0';
            column.flag = 'new';
          });
        }

        this.colDataSource = new MatTableDataSource(this.column_list);
        this.colDataSource.sort = this.sort;
      });


    //******** invoice_total ********//
    query = "SELECT * FROM `invoice_column` WHERE `column_type` = 'invoice_total' AND `status` = '1'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.total_list = data.data['list'];

        // get invoice total columns for invoice design
        if (this.design_model['invoice_design_id'] != '0') {

          query = "SELECT * FROM `invoice_design_total` WHERE `invoice_design_id` = '" +
            this.design_model['invoice_design_id'] + "' AND `status` = '1'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              let total_data = data.data['list'];

              this.total_list.forEach(column => {
                column.invoice_total_id = '0';
                column.is_default = '0';
                column.flag = 'new';
                // column.exist = false;
                total_data.forEach(element => {

                  if (element.invoice_column_id == column.invoice_column_id) {
                    if (this.mode == 'edit')
                      column.invoice_total_id = element.invoice_total_id;

                    column.is_default = '1';
                    // column.exist = true;
                    column.column_width = element.column_width;
                    column.column_seq = element.column_seq;
                    
                    if (this.mode == 'edit')
                      column.flag = 'update';
                    else 
                      column.flag = 'new';
                  }
                });

              });
            });
        }
        else {
          this.total_list.forEach(column => {
            column.invoice_total_id = '0';
            column.flag = 'new';
          });
        }

        this.totalDataSource = new MatTableDataSource(this.total_list);
        this.totalDataSource.sort = this.sort;
      });


    //******** total_content ********//
    query = "SELECT * FROM `invoice_column` WHERE `column_type` = 'total_content' AND `status` = '1'" + 
      " ORDER BY `column_seq`";
    obj = { cmd: 'getList', query: query };
    // let index = 0;
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.all_content_list = data.data['list'];

        // get invoice total content columns for invoice design
        if (this.design_model['invoice_design_id'] != '0') {

          query = "SELECT `invoice_design_total_content`.* FROM `invoice_design_total_content` WHERE" +
            " `invoice_design_id` = '" + this.design_model['invoice_design_id'] + "' AND `status` = '1'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              let content_data = data.data['list'];

              this.all_content_list.forEach(content => {
                content.total_content_id = '0';
                content.is_default = '0';
                content.flag = 'new';
                content.parent_column_id = content.column_id;
                content.content_seq = content.column_seq;
                // column.exist = false;
                content_data.forEach(element => {

                  if (element.column_id == content.invoice_column_id) {
                    if (this.mode == 'edit')
                      content.total_content_id = element.total_content_id;

                    content.is_default = '1';
                    // column.exist = true;
                    content.column_seq = element.column_seq;
                    content.content_title = element.content_title;
                    content.content_title_en = element.content_title_en;
                    content.content_value = element.content_value;
                    
                    if (this.mode == 'edit')
                      content.flag = 'update';
                    else 
                      content.flag = 'new';
                  }
                });
              });

              console.log(this.all_content_list);
            });
        }
        else {
          this.all_content_list.forEach(content => {
            content.total_content_id = '0';
            content.parent_column_id = content.column_id;
            content.content_seq = content.column_seq;
            content.is_default = '0';
            content.flag = 'new';
          });
          console.log(this.all_content_list);
        }

      });
  }

  selectedTab(event) {
    if (event.index == 0 && this.heightField != '') {
      (document.getElementById(this.heightField) as HTMLInputElement).focus();
      this.heightField = '';
    }
  }

  // changeFV(event) {
  //   console.log(this.field_model['field_value']);
  //   console.log(event);

  //   let field_value = this.field_model['field_value'];
  //   let fieldValue = '';
  //   let value;

  //   for (let index = 0; index < field_value.length; index++) {
  //     value = field_value[index];

  //     if (fieldValue != '')
  //       fieldValue += ";";

  //     fieldValue += value;
  //   }
  //   // field_value.forEach(value => {
  //   //   if (fieldValue != '')
  //   //   fieldValue += ";";

  //   //   fieldValue += value;
  //   // });
  //   console.log(fieldValue);
  // }

  ///////////////////////// View Column Content /////////////////////////
  viewColumn(total_column) {
    console.log(total_column);
    this.content_list = [];
    
    this.all_content_list.forEach(element => {
      if (element.parent_column_id == total_column.invoice_column_id) 
        this.content_list.push(element);  
    });
    this.contentDataSource = new MatTableDataSource(this.content_list);
    this.contentDataSource.sort = this.sort;
  }

  ///////////////////////// Add New Field /////////////////////////
  addField() {
    if (this.field_model['show_title'] == 1 && this.field_model['field_title'] == '' && this.field_model['field_title_en'] == '') {
      alert(this.Title_Msg);
      (document.getElementById("field_title") as HTMLInputElement).focus();
    }
    else {
      this.field_model['invoice_design_id'] = this.design_model['invoice_design_id'];
      let fieldIndex;

      if (this.field_model['invoice_field_id']  == '0') {
        if (this.field_model['index'] == undefined) {
          this.field_model['index'] = this.field_list.length;
          this.field_list.push(this.field_model);
        }
        else {
          fieldIndex = this.utils.getDPIndex(this.field_list, 'index', this.field_model['index']);
          this.field_list[fieldIndex] = this.field_model;
        }
      }
      else {
        fieldIndex = this.utils.getDPIndex(this.field_list, 'invoice_field_id', this.field_model['invoice_field_id']);
        this.field_list[fieldIndex] = this.field_model;
      }
      console.log(this.field_list);

      this.fieldDataSource = new MatTableDataSource(this.field_list);
      this.fieldDataSource.sort = this.sort;
      this.field_model = {
        'table_name': 'invoice_design_field', 'invoice_field_id': '0', 'invoice_design_id': '', 'field_title': '',
        'field_title_en': '', 'field_value': '', 'show_title': 1, 'one_line_title': 1, 'is_header': 0,
        'one_box': 0, 'title_font_size': '10', 'title_align': 'R', 'title_width': '0', 'title_height': '7',
        'title_x': '0', 'title_y': '0', 'title_border': 0, 'value_font_size': '10', 'value_align': 'R',
        'flag': 'new', 'key': 'invoice_field_id', 'value_width': '0', 'value_height': '7', 'value_x': '0',
        'value_y': '0', 'value_border': 0, 'comment': ''
      };
    }
  }

  ///////////////////////// Edit Field /////////////////////////
  editField(row) {
    this.field_model = row;
    console.log(row);
  }

  ///////////////////////// Delete Field /////////////////////////
  deleteField(row) {
    if (row.invoice_field_id != '0') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    let fieldIndex = this.utils.getDPIndex(this.field_list, 'index', row.index);
    this.field_list.splice(fieldIndex, 1);
    this.fieldDataSource = new MatTableDataSource(this.field_list);
    this.fieldDataSource.sort = this.sort;
  }

  ///////////////////////// Adding or Deleting Columns /////////////////////////
  change_column(row) {
    let choose = document.getElementById("choose_" + row.invoice_column_id) as HTMLInputElement;
    let column_title = (document.getElementById("column_title_" + row.invoice_column_id) as HTMLInputElement).value;
    let column_title_en = (document.getElementById("column_title_en_" + row.invoice_column_id) as HTMLInputElement).value;
    let column_width = (document.getElementById("column_width_" + row.invoice_column_id) as HTMLInputElement).value;
    let column_seq = (document.getElementById("column_seq_" + row.invoice_column_id) as HTMLInputElement).value;
 
    row.is_default = (choose.checked ? '1' : '0');
    row.column_title = column_title;
    row.column_title_en = column_title_en;
    row.column_width = column_width;
    row.column_seq = column_seq;

    let colIndex = this.utils.getDPIndex(this.column_list, 'invoice_column_id', row.invoice_column_id);
    this.column_list[colIndex] = row;
  }

  ///////////////////////// Save Checked Content Columns /////////////////////////
  change_content(row, type) {
    let choose = document.getElementById("choose_" + row.invoice_column_id) as HTMLInputElement;

    if (type == 'total') {
      row.is_default = (choose.checked ? '1' : '0');
      row.column_width = (document.getElementById("column_width_" + row.invoice_column_id) as HTMLInputElement).value;
      row.column_seq = (document.getElementById("column_seq_" + row.invoice_column_id) as HTMLInputElement).value;

      let totalIndex = this.utils.getDPIndex(this.total_list, 'invoice_column_id', row.invoice_column_id);
      this.total_list[totalIndex] = row;

      if (!choose.checked) {
        this.all_content_list.forEach(element => {
          if (element.parent_column_id == row.invoice_column_id) {
            element.is_default = '0';

            this.content_list.forEach(content => {
              if (content.invoice_column_id == element.invoice_column_id)
                element.is_default = '0';
            });
          }
        });
      }
    }
    else if (type == 'content') {
      if (row.column_value == '')
        row.column_title = (document.getElementById("column_title_" + row.invoice_column_id) as HTMLInputElement).value;

      if (row.column_value == '')
        row.column_title_en = (document.getElementById("column_title_en_" + row.invoice_column_id) as HTMLInputElement).value;

      row.is_default = (choose.checked ? '1' : '0');

      let contentIndex = this.utils.getDPIndex(this.content_list, 'invoice_column_id', row.invoice_column_id);
      this.content_list[contentIndex] = row;

      contentIndex = this.utils.getDPIndex(this.all_content_list, 'invoice_column_id', row.invoice_column_id);
      this.all_content_list[contentIndex] = row;
    }

  }

  ///////////////////////// Save Invoice Design /////////////////////////

  add() {
    if (this.design_model['invoice_design_name'] == '') {
      alert(this.Design_Name_Msg);
      if (this.tabGroup.selectedIndex != 0) {
        this.tabGroup.selectedIndex = 0;
        this.heightField = 'invoice_design_name';
      }
    }

    else {

      let values = [];
      let obj;

      this.design_model['show_page_header'] = (this.design_model['show_page_header'] ? 1 : 0);
      this.design_model['draw_invoice_table'] = (this.design_model['draw_invoice_table'] ? 1 : 0);
      this.design_model['show_table_header'] = (this.design_model['show_table_header'] ? 1 : 0);
      this.design_model['draw_invoice_total'] = (this.design_model['draw_invoice_total'] ? 1 : 0);

      this.design_model['show_terms_table'] = (this.design_model['show_terms_table'] ? 1 : 0);
      this.design_model['draw_terms_table'] = (this.design_model['draw_terms_table'] ? 1 : 0);
      this.design_model['show_terms_header'] = (this.design_model['show_terms_header'] ? 1 : 0);
      this.design_model['one_line_terms_header'] = (this.design_model['one_line_terms_header'] ? 1 : 0);

      if (this.mode == 'copy')
        this.design_model['invoice_design_id'] = '0';

      //******** invoice_design ********//
      values.push(this.design_model);


      //******** invoice_design_field ********//
      let field_value;
      this.field_list.forEach(element => {
        element.show_title = (element.show_title ? 1 : 0);
        element.one_line_title = (element.one_line_title ? 1 : 0);
        element.title_border = (element.title_border ? 1 : 0);
        element.value_border = (element.value_border ? 1 : 0);

        console.log(element.field_value);
        field_value = element.field_value;
        element.field_value = '';
        console.log(field_value);

        if (field_value != '') {
          field_value.forEach(value => {
            if (element.field_value != '')
              element.field_value += ";";
  
            element.field_value += value;
          });
        } 
        delete element.index;

        values.push(element);
      });

      if (this.toDelete.length > 0) {
        this.toDelete.forEach(element => {
          values.push({
            'table_name': element.table_name, 'invoice_field_id': element.invoice_field_id,
            'key': 'invoice_field_id', 'flag': element.flag
          });
        });
      }

      //******** invoice_design_table ********//
      this.column_list.forEach(element => {
        
        if (element.is_default == '1') {
          values.push({
            'table_name': 'invoice_design_table', 'invoice_table_id': element.invoice_table_id,
            'invoice_design_id': this.design_model['invoice_design_id'],
            'invoice_column_id': element.invoice_column_id, 'column_title': element.column_title,
            'column_title_en': element.column_title_en, 'column_width': element.column_width,
            'key': 'invoice_table_id', 'flag': element.flag, 'column_seq': element.column_seq, 'comment': ''
          });
        }
        else if (element.invoice_table_id != '0') {
          values.push({
            'table_name': 'invoice_design_table', 'invoice_table_id': element.invoice_table_id,
            'key': 'invoice_table_id', 'flag': 'delete'
          });
        }
      });

      // let choose, column_width, column_seq;
 
      //******** invoice_design_total ********//
      this.total_list.forEach(element => {
        // this.check_column(element);

        // choose = document.getElementById("choose_" + element.invoice_column_id) as HTMLInputElement;

        if (element.is_default == '1') {
          
          values.push({
            'table_name': 'invoice_design_total', 'invoice_total_id': element.invoice_total_id,
            'invoice_design_id': this.design_model['invoice_design_id'],
            'invoice_column_id': element.invoice_column_id, 'column_title': element.column_title,
            'column_title_en': element.column_title_en, 'column_width': element.column_width,
            'key': 'invoice_total_id', 'flag': element.flag, 'column_seq': element.column_seq, 'comment': ''
          });
        }
        else if (element.invoice_total_id != '0') {
          values.push({
            'table_name': 'invoice_design_total', 'invoice_total_id': element.invoice_total_id,
            'key': 'invoice_total_id', 'flag': 'delete'
          });
        }

      });

      //******** invoice_design_total_content ********//
      this.all_content_list.forEach(element => {

        if (element.is_default == '1') {
          values.push({
            'table_name': 'invoice_design_total_content', 'total_content_id': element.total_content_id,
            'invoice_design_id': this.design_model['invoice_design_id'],
            'column_id': element.invoice_column_id, 'parent_column_id': element.parent_column_id, 
            'content_seq': element.column_seq, 'content_title': element.column_title, 
            'content_title_en': element.column_title_en, 'content_value': element.column_value, 
            'key': 'total_content_id', 'flag': element.flag, 'comment': ''
          });
        } 
        else if (element.total_content_id != '0') {
          values.push({
            'table_name': 'invoice_design_total_content', 'total_content_id': element.total_content_id,
            'key': 'total_content_id', 'flag': 'delete'
          });
        }
      });


      //******** saving ********//
      console.log(values);

      if (this.design_model['invoice_design_id'] == '0')
        obj = { cmd: 'add', values: values, pk: 'invoice_design_id', id: 'invoice_design_id', 
          main_table: 'invoice_design' };
      else if (this.design_model['invoice_design_id'] != '0' && this.mode == 'edit')
        obj = { cmd: 'updateAdv', values: values };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {

          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.router.navigate(['sub_menu/5/invoice_design_list']);
          }
          else 
            alert(this.Error_Msg);
  
        });

    }
  }

}
